import React from "react";
import { t } from "i18next";
import { useLocation } from "react-router-dom";

function Maintenance() {
  const location = useLocation();
  const period = location.state?.period;
  return (
    <div className="flex h-screen items-center justify-center bg-white font-sans text-center text-gray-800">
      <div className="max-w-md p-5 w-full">
        <h1 className="mb-4 text-2xl font-semibold text-black">
          {t("errorpage_inspection_title")}
        </h1>
        <p
          className="mb-6 text-gray-400 text-sm"
          dangerouslySetInnerHTML={{ __html: t("errorpage_inspection_desc") }}
        ></p>
        {period && (
          <div className="rounded-xl bg-gray-100 px-5 py-4 text-left w-full">
            <p className="text-sm text-gray-800 font-bold">
              {t("errorpage_inspection_datetime")}
            </p>
            <p className="pt-1 text-sm text-gray-500">
              {t("fanevent.error.inspection.content2", {
                month: period.month,
                day: period.day,
                timerange: `${period.startAt}${period.endAt ? " ~ " + period.endAt : ""}`,
              })}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Maintenance;
